import service from '@/helpers/serviceBO'

export function obtenirPasswordCrypteBO(user, pass) {
    let model = {
        login: user,
        password: pass,
        rememberMe: true
    }
    return service.post("/Fournisseurs/Account/LoginFromAnotherSiteEncryptePassword?ReturnUrl=%2FFournisseurs%2FMonCompte", model)
  }

